import React, { useState } from 'react';
import { ZoomIn, ZoomOut, Layers, Filter, Navigation } from 'lucide-react';

interface MapControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onToggleLayers?: () => void;
  onToggleFilters?: () => void;
  onCenterMap?: () => void;
  showLayers?: boolean;
  showFilters?: boolean;
}

const MapControls: React.FC<MapControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onToggleLayers,
  onToggleFilters,
  onCenterMap,
  showLayers = false,
  showFilters = false,
}) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="absolute top-4 left-4 z-[1000] flex flex-col gap-2">
      {/* Zoom Controls */}
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        <button
          onClick={onZoomIn}
          className="p-3 hover:bg-gray-100 transition-colors border-b border-gray-200"
          title="Zoom In"
        >
          <ZoomIn className="w-5 h-5 text-gray-700" />
        </button>
        <button
          onClick={onZoomOut}
          className="p-3 hover:bg-gray-100 transition-colors"
          title="Zoom Out"
        >
          <ZoomOut className="w-5 h-5 text-gray-700" />
        </button>
      </div>

      {/* Additional Controls */}
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {onCenterMap && (
          <button
            onClick={onCenterMap}
            className="p-3 hover:bg-gray-100 transition-colors border-b border-gray-200"
            title="Center Map"
          >
            <Navigation className="w-5 h-5 text-gray-700" />
          </button>
        )}
        {onToggleLayers && (
          <button
            onClick={onToggleLayers}
            className={`p-3 hover:bg-gray-100 transition-colors border-b border-gray-200 ${
              showLayers ? 'bg-blue-50' : ''
            }`}
            title="Layers"
          >
            <Layers className="w-5 h-5 text-gray-700" />
          </button>
        )}
        {onToggleFilters && (
          <button
            onClick={onToggleFilters}
            className={`p-3 hover:bg-gray-100 transition-colors ${
              showFilters ? 'bg-blue-50' : ''
            }`}
            title="Filters"
          >
            <Filter className="w-5 h-5 text-gray-700" />
          </button>
        )}
      </div>
    </div>
  );
};

export default MapControls;
